export default "__VITE_ASSET__35945790__"